export const displayTimingGroupTranslationEN = {
  DisplayTimingGroup: {},
};
